import { Injectable } from '@angular/core';
import { LocalstorageService } from './../../shared/services/localstorage.service';

import { LoggedUser } from './../../models/shared/loggedUser.model';

import * as appConfig from '../../app.config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './../../shared/services/api.service';
import { Router } from '@angular/router';
import { AlertService } from './../../shared/services/alert.service';

const LOGOUT_MESSAGE = 'Odhlášení proběhlo úspěšně.';

@Injectable()
export class AuthenticationService {
  private _loggedUser: LoggedUser = null;

  public static getBearerToken(): string | boolean {
    let token = false;
    const currentTime: number = (new Date()).getTime();

    const loggedUser: any = LocalstorageService.retrieve(appConfig.authTokenKey);

    if (loggedUser && loggedUser.expires > currentTime) {
      token = loggedUser.token;
    }
    return token;
  }

  public isLoggedIn(): boolean {
    const currentTime: number = (new Date()).getTime();
    if (this._loggedUser && this._loggedUser.expires > currentTime) {
      return true;
    }
    return false;
  }

  constructor(
    private _apiService: ApiService,
    private _router: Router,
    private _alertService: AlertService
  ) {
    // set token if saved in local storage
    const loggedUser: any = LocalstorageService.retrieve(appConfig.authTokenKey);
    if (loggedUser && loggedUser.token && loggedUser.expires && loggedUser.username) {
      this._loggedUser = new LoggedUser({
        token: loggedUser.token,
        username: loggedUser.username,
        expires: loggedUser.expires,
        file: loggedUser.file
      });
    }
  }

  login(username: string, password: string): Observable<boolean> {
    const userData: any = { 'username': username, 'password': password };

    return this._apiService.post(userData, 'users/login')
    .pipe(
      map((response: any) => {
        const res = { ...response };
        if (res.success && res.data) {
          const responseData = res.data;
          const tokenData = new LoggedUser({
            expires: responseData.expires,
            token: responseData.token,
            username: responseData.username,
            file: responseData.file
          });

          LocalstorageService.store(appConfig.authTokenKey, tokenData);

          this._loggedUser = tokenData;

          // return true to indicate successful login
          return true;
        }

        return false;

      })
      );
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    LocalstorageService.remove(appConfig.authTokenKey);
    this._router.navigate(['/login']);
    this._alertService.success(LOGOUT_MESSAGE);
  }

  /**
   * get username method
   * @return string
   */
  getUsername() {
    let username = '';
    if (this._loggedUser && this._loggedUser.username) {
      username = this._loggedUser.username;
    }
    return username;
  }

}
